import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../header/Header';
import Footer from '../footer/Footer';

export default function Shell() {
  return (
    <main className="main">
      <Header />
      <Outlet />
      <Footer />
    </main>
  );
}
